import { useInjection } from 'inversify-react'
import { StreamStore } from 'store/stream'
import T from '../../config/inversify.types'

export function useStreamStore(): StreamStore {
    return useInjection<StreamStore>(T.StreamStore)
}
